"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = exports.BREAKPOINTS = void 0;
const react_1 = require("react");
const useResizeObserver_1 = __importDefault(require("./useResizeObserver"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.BREAKPOINTS = {
    md: parseInt((0, ui_theme_1.fromTheme)('screen_medium')({})),
    sm: parseInt((0, ui_theme_1.fromTheme)('screen_small')({}))
};
const defaultBreakpoints = [
    ['md', exports.BREAKPOINTS.md],
    ['sm', exports.BREAKPOINTS.sm]
    // NOTE: for reference only: We don't change layout above `md`
    // ['lg', parseInt(fromTheme('screen_large')({}))]
];
const useBreakpoints = (breakpoints = defaultBreakpoints) => {
    const [breakpoint, setBreakpoint] = (0, react_1.useState)('');
    const { ref } = (0, useResizeObserver_1.default)({
        onResize: (0, react_1.useCallback)(({ width }) => {
            for (const [_breakpoint, _breakpointWidth] of breakpoints) {
                if (width >= _breakpointWidth) {
                    setBreakpoint(_breakpoint);
                    break;
                }
            }
        }, [breakpoints])
    });
    return {
        ref,
        breakpoint
    };
};
exports.useBreakpoints = useBreakpoints;
//# sourceMappingURL=useBreakpoints.js.map